import { useEffect, useState } from 'react';
import { ETestIds } from 'shared/constants/testIds';
import { useIsDesktop } from '../../../../hooks/common';

export const useResetButtonVisibility = (enabled: boolean, hasOffers: boolean, isFetching: boolean): boolean => {
  const isDesktop = useIsDesktop();
  const [isResetButtonVisible, setIsResetButtonVisible] = useState(false);

  useEffect(() => {
    if (isDesktop || !enabled || hasOffers || isFetching) {
      setIsResetButtonVisible(false);

      return;
    }

    let observer: IntersectionObserver | null = null;

    const attachObserver = () => {
      const resetButton = document.querySelector(`[data-testid=${ETestIds.ShortOffersResetFiltersButton}]`);

      if (!resetButton) {
        setIsResetButtonVisible(false);

        return;
      }

      observer?.disconnect();
      observer = new IntersectionObserver(
        ([entry]) => {
          setIsResetButtonVisible(entry.isIntersecting);
        },
        { threshold: 0 },
      );
      observer.observe(resetButton);
    };

    attachObserver();
    const rafId = requestAnimationFrame(attachObserver);

    return () => {
      cancelAnimationFrame(rafId);
      observer?.disconnect();
    };
  }, [enabled, isDesktop, hasOffers, isFetching]);

  return isResetButtonVisible;
};
